/**
 * wtc-vault #46 on Hub sign-out: end the vault unlock session on the vault while the access token
 * still works, and tell the extension in this browser to lock (it ends its copy on the vault too).
 *
 * Browser only. Loaded lazily so the sign-out path does not pull the vault UI into every page.
 * Bounded and silent: sign-out never waits more than ~1.5 s on the vault and never fails because
 * of it. No token or response body is logged.
 */
import { tellExtensionLocked } from "./extension-handoff";

export async function endVaultBeforeSignOut(timeoutMs = 1500): Promise<void> {
  if (typeof window === "undefined") return;
  tellExtensionLocked();
  try {
    const { endVaultSession } = await import("@west-tennessee-consulting/vault-ui/unlock-context");
    await endVaultSession(timeoutMs);
  } catch {
    // The vault's own idle and hard limits still end the session.
  }
}
